import $ from 'jquery';
import { disableElement } from '../utils/input';
import { trimTrailingSlashes } from '../utils/string';
const ELEMENT_SELECTOR = '.js__soft-validation-messages';
export class SoftValidationMessages {
    static xhrRequest = null;
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.each((index, element) => {
            if (!$(element).hasClass('js__soft-validation-actions-added')) {
                this.initActions($(element), $root);
                $(element).addClass('js__soft-validation-actions-added');
            }
        });
    }
    static initActions($element, $root) {
        const { url, onChangeElement, valueInput, elementsToToggle, hideOnElementsChange, matchValue } = $element.data();
        const $valueInput = $(valueInput);
        $root.on('change', onChangeElement, e => {
            const hasError = $valueInput.closest('.field').hasClass('error');
            const $onChangeElement = $(e.currentTarget);
            if (!hasError && $onChangeElement.val() === matchValue) {
                this.handleSearch($element, url, $valueInput, elementsToToggle, onChangeElement);
                this.initElementsHideOnChange(hideOnElementsChange, elementsToToggle, $element);
            }
        });
        const hasError = $valueInput.closest('.field').hasClass('error');
        if (!hasError && $valueInput.val() && $(onChangeElement).val() === matchValue) {
            this.handleSearch($element, url, $valueInput, elementsToToggle, onChangeElement);
            this.initElementsHideOnChange(hideOnElementsChange, elementsToToggle, $element);
        }
    }
    static initElementsHideOnChange(hideOnElementsChange, elementsToToggle, $messagesElement) {
        hideOnElementsChange.split(',').forEach(selector => {
            $(selector).on('change', e => {
                disableElement($(elementsToToggle), true, '', false, true);
                $messagesElement.addClass('hidden');
            });
        });
    }
    static handleSearch($messagesElement, url, $valueInput, elementsToToggle, onChangeElement) {
        if (this.xhrRequest) {
            this.xhrRequest.abort();
            this.xhrRequest = null;
        }
        this.xhrRequest = $.ajax({
            method: 'GET',
            url: trimTrailingSlashes(url.replace('%25inputValue%25', String($valueInput.val()))),
            beforeSend: () => {
                $messagesElement.html('');
                onChangeElement.split(',').forEach(selector => {
                    $(selector).closest('.dropdown').addClass('loading');
                });
                $messagesElement.addClass('hidden');
            },
        })
            .done(() => {
            $messagesElement.addClass('hidden');
            disableElement($(elementsToToggle), true, '', false, true);
        })
            .fail((xhr) => {
            if (xhr.status === 400 && xhr.responseJSON) {
                Object.entries(xhr.responseJSON.errors).forEach(([key, value]) => {
                    value.forEach(message => {
                        $messagesElement.append(`<p>${message}</p>`);
                    });
                });
                $messagesElement.removeClass('hidden');
                disableElement($(elementsToToggle), false, '', false, true);
            }
        })
            .always(() => {
            onChangeElement.split(',').forEach(selector => {
                $(selector).closest('.dropdown').removeClass('loading');
            });
        });
    }
}
